export default "__VITE_ASSET__C7_GREu3__"